export const ID_NEW_SETUP = "newSetup";
export const HELP_TOOLTIP_TITLE = "Double-click on any row to edit the information for that entry.";
